(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var INTERVAL = 3000;
  var RESUME_DELAY = 5000;
  var GAP = 24;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var scrollers = document.querySelectorAll('[data-features-scroller]');
  if (!scrollers.length) return;

  Array.prototype.forEach.call(scrollers, setup);

  function setup(viewport) {
    var wrap = viewport.parentElement;
    if (!wrap) return;
    var prevBtn = wrap.querySelector('[data-features-prev]');
    var nextBtn = wrap.querySelector('[data-features-next]');
    var allCards = viewport.querySelectorAll('.p-features-marquee__card');
    if (!allCards.length) return;

    var isCircular = viewport.getAttribute('data-features-loop') === 'circular';
    var originalCount = parseInt(viewport.getAttribute('data-original-count'), 10) || allCards.length;
    var middleCards = viewport.querySelectorAll('.p-features-marquee__card[data-clone-set="2"]');

    var autoTimer = null;
    var resumeTimer = null;
    var teleportFrame = null;

    function getStep() {
      var rect = allCards[0].getBoundingClientRect();
      return rect.width + GAP;
    }
    function middleStart() {
      if (!isCircular || !middleCards.length) return 0;
      return middleCards[0].offsetLeft;
    }
    function middleEnd() {
      if (!isCircular || !middleCards.length) return viewport.scrollWidth - viewport.clientWidth;
      var lastMid = middleCards[middleCards.length - 1];
      return lastMid.offsetLeft + lastMid.offsetWidth - viewport.clientWidth + GAP;
    }
    function recenter() {
      if (!isCircular) return;
      viewport.style.scrollBehavior = 'auto';
      viewport.scrollLeft = middleStart();
      requestAnimationFrame(function () { viewport.style.scrollBehavior = ''; });
    }

    function step(direction) {
      var s = getStep();
      var current = viewport.scrollLeft;
      var target = (direction === 'next') ? current + s : current - s;
      viewport.scrollTo({ left: target, behavior: 'smooth' });
    }

    function maybeTeleport() {
      if (!isCircular) return;
      var current = viewport.scrollLeft;
      var ms = middleStart();
      if (ms <= 0) return;
      var oneSet = ms;
      if (current < ms - oneSet * 0.5) {
        viewport.style.scrollBehavior = 'auto';
        viewport.scrollLeft = current + oneSet;
        requestAnimationFrame(function () { viewport.style.scrollBehavior = ''; });
      } else if (current > ms + oneSet * 1.5) {
        viewport.style.scrollBehavior = 'auto';
        viewport.scrollLeft = current - oneSet;
        requestAnimationFrame(function () { viewport.style.scrollBehavior = ''; });
      }
    }

    function startAuto() {
      if (prefersReducedMotion) return;
      stopAuto();
      autoTimer = setInterval(function () { step('next'); }, INTERVAL);
    }
    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }
    function pauseThenResume() {
      stopAuto();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAuto, RESUME_DELAY);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step('prev'); pauseThenResume(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step('next'); pauseThenResume(); });

    wrap.addEventListener('pointerenter', stopAuto);
    wrap.addEventListener('pointerleave', startAuto);
    viewport.addEventListener('touchstart', stopAuto, { passive: true });
    viewport.addEventListener('touchend', pauseThenResume, { passive: true });

    var scrollDebounce = null;
    viewport.addEventListener('scroll', function () {
      if (scrollDebounce) clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(maybeTeleport, 80);
    }, { passive: true });

    function init() {
      recenter();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) startAuto();
            else stopAuto();
          });
        }, { threshold: 0.25 });
        io.observe(viewport);
      } else {
        startAuto();
      }
    }

    var firstImg = allCards[0].querySelector('img');
    if (!firstImg || firstImg.complete) {
      init();
    } else {
      firstImg.addEventListener('load', init, { once: true });
      firstImg.addEventListener('error', init, { once: true });
      window.addEventListener('load', init, { once: true });
    }

    // Only recenter on width-change (orientation/resize), NOT on URL bar collapse (height change).
    // Mobile scroll triggers viewport height changes that fire resize → was forcibly recentering to 01.
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        recenter();
      }
    }, { passive: true });
  }
})();
